<mat-chip
    *ngIf="categoryId && getCategoryName(categoryId)"
    style="font-size: inherit; height: 25px"
    [ngStyle]="{ 'background-color': bgColor }"
>
    <span [ngStyle]="{ color: textColor }">
        {{ getCategoryName(categoryId) }}
    </span>
</mat-chip>
